import React from 'react';

import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { useFormContext } from 'react-hook-form';
import { stepIconClasses, styled } from '@mui/material';

const CustomStep = styled(Step)(({ theme }) => ({
  color: '#FFFFFF',
}));

const CustomStepLabel = styled(StepLabel)(({ theme }) => ({
  [`& .${stepIconClasses.text}`]: {
    fill: '#FFFFFF',
  },
  [`& .${stepIconClasses.completed}`]: {
    fill: theme.palette.primary,
  },
  [`& .${stepIconClasses.active}`]: {
    fill: theme.palette.primary,
  },
}));

interface Props {
  steps: string[];
}

export const HorizontalSteps: React.FC<Props> = ({ steps }) => {
  const { watch } = useFormContext();

  const activeStep = watch('activeStep');

  return (
    <Box sx={{ width: '100%' }} my={5}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <CustomStep key={label}>
            <CustomStepLabel>{label}</CustomStepLabel>
          </CustomStep>
        ))}
      </Stepper>
    </Box>
  );
};
